<template>
    <ModalTemplate
        :show="show"
        :headless="true"
        :close-button="true"
        @close="$emit('close')"
        width="max-w-4xl w-full"
        padding="p-0"
    >
        <div class="rounded-modal overflow-hidden">
            <div
                class="bg-white px-6 py-8 relative min-h-[60dvh] max-h-[80dvh] overflow-y-auto flex flex-col gap-2"
            >
                <div
                    v-for="pageNumber in pageNumbers"
                    :key="pageNumber"
                    class="border border-border"
                >
                    <canvas :ref="`pageCanvas-${pageNumber}`" />
                </div>
            </div>
        </div>
    </ModalTemplate>
</template>

<script>
import ModalTemplate from '@/Components/Templates/ModalTemplate.vue'
import {
    version,
    getDocument,
    GlobalWorkerOptions,
    VerbosityLevel,
} from 'pdfjs-dist'

GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.
worker.min.js`
GlobalWorkerOptions.verbosity = VerbosityLevel.ERRORS

export default {
    name: 'PdfModal',
    components: {
        ModalTemplate,
    },

    emits: ['close'],

    props: {
        show: {
            type: Boolean,
            required: true,
        },
        pdfUrl: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            pdfDoc: null,
            currentPage: 1,
            pageNumbers: [],
        }
    },

    methods: {
        loadPdf() {
            try {
                // Load the PDF document
                getDocument(this.pdfUrl).promise.then((pdf) => {
                    this.pdfDoc = () => pdf
                    this.pageNumbers = Array.from(
                        { length: pdf.numPages },
                        (_, i) => i + 1
                    )

                    this.pageNumbers.forEach((pageNumber) => {
                        this.renderPage(pageNumber)
                    })
                })
            } catch (error) {
                console.error('Error loading PDF:', error)
            }
        },

        async renderPage(pageNumber) {
            try {
                const page = await this.pdfDoc().getPage(pageNumber)

                const viewport = page.getViewport({ scale: 1.5 })

                const pageCanvasRef = this.$refs[`pageCanvas-${pageNumber}`]

                if (!pageCanvasRef || pageCanvasRef.length === 0) {
                    console.error(
                        `Canvas for page ${pageNumber} is not available.`
                    )
                    return
                }
                const canvas = pageCanvasRef[0]

                canvas.height = viewport.height
                canvas.width = viewport.width

                const renderContext = {
                    canvasContext: canvas.getContext('2d'),
                    viewport: viewport,
                }
                await page.render(renderContext).promise
            } catch (error) {
                console.error(`Error rendering page ${pageNumber}:`, error)
            }
        },

        unloadPdf() {
            if (this.pdfDoc && this.pdfDoc()) {
                this.pdfDoc().destroy()
                this.pdfDoc = null
            }
        },
    },

    watch: {
        show(newVal) {
            if (newVal) {
                this.loadPdf()
            } else {
                this.unloadPdf()
            }
        },
    },

    mounted() {
        if (this.show) {
            this.loadPdf()
        }
    },

    beforeUnmount() {
        this.unloadPdf()
    },
}
</script>

<style scoped>
canvas {
    max-width: 100%;
    height: auto;
}
</style>
